
import { supabase } from '@/integrations/supabase/client';
import { Profile } from '@/types/database.types';

export interface AdminUserAction {
  targetUserId: string;
  operation: 'updateUserType' | 'deleteUser' | 'assignPEO';
  userType?: string;
  providerId?: string;
}

export class AdminUserManagementService {
  static async manageUser(params: AdminUserAction) {
    const { data, error } = await supabase.functions.invoke('admin-user-operations', {
      body: {
        operation: params.operation,
        targetUserId: params.targetUserId,
        userType: params.userType,
        providerId: params.providerId
      }
    });

    if (error) {
      console.error(`Failed to ${params.operation}:`, error);
      throw error;
    }

    return data;
  }

  static async updateUserType(userId: string, userType: string) {
    return this.manageUser({
      targetUserId: userId,
      operation: 'updateUserType',
      userType
    });
  }

  static async deleteUser(userId: string) {
    return this.manageUser({
      targetUserId: userId,
      operation: 'deleteUser'
    });
  }

  static async assignPEO(userId: string, providerId: string) {
    return this.manageUser({
      targetUserId: userId,
      operation: 'assignPEO',
      providerId
    });
  }
}
